import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const ClockWithArrowIcon = ({
  width = "24",
  height = "24",
  color = "white",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 3C11.1131 3 8.82387 3.94821 7.13604 5.63604C5.44821 7.32387 4.5 9.61305 4.5 12H1.5L5.39 15.89L5.46 16.03L9.5 12H6.5C6.5 8.13 9.63 5 13.5 5C17.37 5 20.5 8.13 20.5 12C20.5 15.87 17.37 19 13.5 19C11.57 19 9.82 18.21 8.56 16.94L7.14 18.36C7.97328 19.1982 8.96433 19.863 10.0559 20.3162C11.1475 20.7693 12.3181 21.0017 13.5 21C15.8869 21 18.1761 20.0518 19.864 18.364C21.5518 16.6761 22.5 14.3869 22.5 12C22.5 9.61305 21.5518 7.32387 19.864 5.63604C18.1761 3.94821 15.8869 3 13.5 3ZM12.5 8V13L16.78 15.54L17.5 14.33L14 12.25V8H12.5Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
